import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Column.svg",
  "use": "Column.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Column.svg\"><path d=\"M51.0106,51.0208h-38a4,4,0,0,1-4-4v-30a4,4,0,0,1,4-4h38a4,4,0,0,1,4,4v30A4,4,0,0,1,51.0106,51.0208Zm-28-33a1,1,0,0,0-1-1h-8a1,1,0,0,0-1,1v28a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1Zm14,0a1,1,0,0,0-1-1h-8a1,1,0,0,0-1,1v28a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1Zm14,0a1,1,0,0,0-1-1h-8a1,1,0,0,0-1,1v28a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol